export enum LicenseType {
  DOCTOR_CERTIFICATE_FRONT_FILE = 'DOCTOR_CERTIFICATE_FRONT_FILE',
  DOCTOR_CERTIFICATE_BACK_FILE = 'DOCTOR_CERTIFICATE_BACK_FILE',
  APPROBATION_CERTIFICATE_FILE = 'APPROBATION_CERTIFICATE_FILE',
  SPECIALTY_CERTIFICATE_FILE = 'SPECIALTY_CERTIFICATE_FILE',
}